var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPerson40 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.25C28.9746 36.25 36.25 28.9746 36.25 20C36.25 11.0254 28.9746 3.75 20 3.75C11.0254 3.75 3.75 11.0254 3.75 20C3.75 28.9746 11.0254 36.25 20 36.25Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 1.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C22.5889 10 24.6875 12.0987 24.6875 14.6875C24.6875 17.2764 22.5889 19.375 20 19.375C17.4111 19.375 15.3125 17.2764 15.3125 14.6875C15.3125 12.0987 17.4111 10 20 10ZM20 8.125C16.3756 8.125 13.4375 11.0631 13.4375 14.6875C13.4375 18.3119 16.3756 21.25 20 21.25C23.6244 21.25 26.5625 18.3119 26.5625 14.6875C26.5625 11.0631 23.6244 8.125 20 8.125ZM29.375 34.375H27.5V29.6875C27.5 28.4443 27.0061 27.252 26.1271 26.3729C25.248 25.4939 24.0557 25 22.8125 25H17.1875C14.5986 25 12.5 27.0986 12.5 29.6875V34.375H10.625V29.6875C10.625 26.0631 13.5631 23.125 17.1875 23.125H22.8125C26.4369 23.125 29.375 26.0631 29.375 29.6875V34.375Z",
    fill: "#CACACA"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson40);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-40.8a7659a2df6aaccbd15a2bc0e22be13c.svg";